export const breaksTitles = ['Sickness', 'Unpaid', 'Vacation'];
